import "core-js/modules/es.object.keys.js";
import _slicedToArray from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _typeof from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/typeof";
import Vue from 'vue';
import processing from '../util/processing';
export default {
  directives: {
    countdown: {
      bind: function bind(el, binding, vnode) {
        var val = +binding.value;

        if (typeof val !== 'number') {
          return;
        }

        var componentOptions = vnode.componentOptions,
            data = vnode.data;
        var listeners = componentOptions ? componentOptions.listeners : null;
        var on = data ? data.on : null;
        var events = listeners || on || null;

        if (events && _typeof(events) === 'object' && Object.keys(events).length) {
          // eslint-disable-next-line no-param-reassign
          binding.customListeners = events;
        }

        var oldVal = val;
        var startTime = Date.now(); // const { mode = 'auto' } = (vnode.data || {}).attrs || {}

        var timer = null;
        window.clearInterval(el.timer);
        Vue.nextTick(function () {
          var _ref = el.querySelectorAll('i') || [],
              _ref2 = _slicedToArray(_ref, 3),
              hDom = _ref2[0],
              mDom = _ref2[1],
              sDom = _ref2[2];

          var tFunction = function tFunction() {
            if (val <= 0) {
              if (timer) {
                window.clearInterval(timer);
                timer = null;

                if (binding.customListeners) {
                  // eslint-disable-next-line no-unused-expressions
                  binding.customListeners.complete && binding.customListeners.complete();
                }
              }

              return;
            }

            var offsetSeconds = parseInt((Date.now() - startTime) / 1000, 10);
            val = oldVal - offsetSeconds * 1000;
            val = val < 0 ? 0 : val; // val -= 1000

            var instance = processing.milliseconds2DHMS(val); // 返回的是 数组[天，小时，分钟，秒]
            // eslint-disable-next-line no-unused-expressions

            hDom && (hDom.innerHTML = processing.toZeroStr(instance[0] ? instance[0] : instance[1])); // eslint-disable-next-line no-unused-expressions

            mDom && (mDom.innerHTML = processing.toZeroStr(instance[0] ? instance[1] : instance[2])); // eslint-disable-next-line no-unused-expressions

            sDom && (sDom.innerHTML = processing.toZeroStr(instance[0] ? instance[2] : instance[3])); // if (mode === 'auto') {
            //   hDom.nextSibling.textContent = instance[0] ? '天' : '时'
            //   mDom.nextSibling.textContent = instance[0] ? '时' : '分'
            //   if (sDom.nextSibling) {
            //     sDom.nextSibling.textContent = instance[0] ? '分' : '秒'
            //   }
            // }
          };

          tFunction();
          timer = window.setInterval(tFunction, 1000); // eslint-disable-next-line no-param-reassign

          el.timer = timer;
        });
      },
      update: function update(el, binding, vnode) {
        if (binding.oldValue !== binding.value) {
          window.clearInterval(el.timer);
          binding.def.bind(el, binding, vnode);
        }
      },
      unbind: function unbind(el, binding) {
        window.clearInterval(el.timer); // eslint-disable-next-line no-param-reassign

        el.timer = null; // eslint-disable-next-line no-param-reassign

        delete el.timer;
        var customListeners = binding.customListeners;

        if (customListeners) {
          // eslint-disable-next-line no-param-reassign
          delete binding.customListeners;
        }
      }
    }
  }
};